import { useQuery, gql } from '@apollo/client';

const CATEGORY_RAIL_QUERY = gql`
  query CategoryRailNavigation(
    $categoryId: String!,
    $displayTypes: [String!]!,
    $includeDropDownValue: Boolean!
  ) {
    category(categoryId: $categoryId) {
      localNavigation {
        displayTypes(displayTypes: $displayTypes) {
          bottomEspot {
            espotId
            htmlContent
            timestamp
          }
          categories {
            categoryId
            displayTypes(displayTypes: $displayTypes) {
              categories {
                categoryId
                isCurrent
                listItemQaAttribute
                name
                url
              }
              displayType
            }
            isCurrent
            listItemQaAttribute
            name
            url
          }
          displayType
          heading {
            key
            value
          }
        }
        headingLabel
        headingQaAttribute
        headingScreenReaderOnly
        headingUrl
        rootCategoryId
      }
      dropdownTopValue @include(if: $includeDropDownValue)
    }
  }
`;

function useFetchLocalNavQuery(categoryId, includeDropDownValue = false) {
  const { data, loading, error } = useQuery(CATEGORY_RAIL_QUERY, {
    variables: {
      categoryId,
      displayTypes: ['regular', 'featured', 'clearance'],
      includeDropDownValue,
    },
  });

  return {
    loading,
    error,
    categoryData: data?.category,
  };
}

export default useFetchLocalNavQuery;
